import ArtifactGroupType from "../base/ArtifactGroupType";


const AmuletOfKhepri = {
  id: '107',
  name: 'Amulet Of Khepri',
  groupIcon: 'TreasuresOfTheNile',
  type: ArtifactGroupType.TREASURES_OF_THE_NILE,
  icon: 'AmuletOfKhepri',
  power: 10
};

export default AmuletOfKhepri;
